<ng-template>
  <div @slideoverpanel [class]="class">
    <!-- <div class="py-1"> -->
    <ng-content></ng-content>
    <!-- </div> -->
  </div>
</ng-template>